import React, { Component } from "react";
import {
  Row,
  Card,
  CardTitle,
  Label,
  Button,
  FormGroup,
  Input,
} from "reactstrap";

import { connect } from "react-redux";
import { registerUser } from "../../redux/actions";

// import IntlMessages from "../../helpers/IntlMessages";
import { Colxx } from "../../components/common/CustomBootstrap";
import axios from "../../containers/api";

import { toEnglishNumbers } from "../../helpers/Utils";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Link } from "react-router-dom";
class RegisterProductOwner extends Component {
  constructor(props) {
    super(props);
    this.fileUploader = React.createRef();
    this.state = {
      SendActiveCode: true,
      CheckActiveCode: false,
      IsActive: false,
      Mobile: "",
      ActiveCode: "",
      Register: false,
      Firstname: "",
      Lastname: "",
      MeliCode: "",
      newMemberUsername: "",
      newMemberPassword: "",
      showNewMember: false,
      errors: [],
      file: null, //uploaded picture
      Province: null,
      CityList: [],
      City: null,
      ProvinceList: [],
      Mobile:
        this.props.location.state !== undefined &&
        this.props.location.state !== null
          ? this.props.location.state[0].mobile !== null &&
            this.props.location.state[0].mobile !== undefined
            ? this.props.location.state[0].mobile
            : null
          : null,
    };
    // console.log("test")
  }
  onUserRegister() {
    if (this.state.email !== "" && this.state.password !== "") {
      this.props.history.push("/");
    }
  }
  componentWillMount() {
    this.loadProvinces();
  }
  loadProvinces = () => {
    // this.props.showSpinner();
    axios
      .get("api/v1/Province/GetAll")
      .then((res) => {
        //   this.props.hideSpinner();
        this.setState({ ProvinceList: res.data.data });
      })
      .catch((error) => {
        // this.props.hideSpinner();
        // this.props.showAlert(showCatchError(error), "error");
        console.log(error.response);
      });
  };
  loadCities = (id) => {
    //this.props.showSpinner();
    axios
      .get("api/v1/City/GetCityByProvinceId?provinceId=" + id)
      .then((res) => {
        //  this.props.hideSpinner();
        this.setState({ CityList: res.data.data });
      })
      .catch((error) => {
        // this.props.hideSpinner();
        // this.props.showAlert(showCatchError(error), "error");
        console.log(error.response);
      });
  };
  selectHandleChange = (event, value, name) => {
    this.setState({ [name]: value }, () => {
      if (name === "Province") {
        if (value !== undefined && value !== null) {
          this.setState(
            {
              City: null,
            },
            () => this.loadCities(value.provinceId),
          );
        } else {
          this.setState({
            City: null,
            CityList: [],
          });
        }
      }
    });
  };
  validateInputData = () => {
    //this.props.closeSweetAlert();
    let error = [];
    if (this.state.Firstname.length === 0) {
      error.push("وارد كردن نام  الزامی میباشد");
    }
    if (this.state.Lastname.length === 0) {
      error.push("وارد كردن نام خانوادگي الزامی میباشد");
    }
    if (this.state.MeliCode.length < 10) {
      error.push("کد ملی نباید کمتر از ۱۰ حرف باشد.");
    }
    if (this.state.Mobile.length === 0) {
      error.push("وارد كردن تلفن يا موبايل الزامی میباشد.");
    }
    if (this.state.file === null) {
      error.push("لطفا فایل مورد نظر را انتخاب کنید");
    }
    if (this.state.City === null || this.state.City === undefined) {
      error.push("انتخاب شهر الزامی میباشد.");
    }

    this.setState({ errors: error });
    if (error.length === 0) {
      this.AddProductOwner();
    } else {
      this.props.showAlert(error, "error");
    }
  };

  AddProductOwner = () => {
    let addModel = new FormData();
    addModel.set("Firstname", toEnglishNumbers(this.state.Firstname));
    addModel.set("Lastname", toEnglishNumbers(this.state.Lastname));
    addModel.set("MeliCode", toEnglishNumbers(this.state.MeliCode));
    addModel.set("Mobile", toEnglishNumbers(this.state.Mobile));
    addModel.set(
      "CityId",
      this.state.City !== null ? this.state.City.cityId : null,
    );
    addModel.append("File", this.state.file);

    //this.props.showSpinner();
    axios
      .post("api/v1/ProductOwner/AddProductOwner", addModel, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        //this.props.hideSpinner();
        if (res.status === 200 && res.data.data.code !== -1) {
          this.setState({
            newMemberUsername: res.data.data.data.userName,
            newMemberPassword: res.data.data.data.password,
            Register: false,
            showNewMember: true,
          });
        } else {
          this.props.showAlert(res.data.data.message, "error");
        }
      })
      .catch((error) => {
        //this.props.hideSpinner();
        //this.props.showAlert(showCatchError(error), "error");
        console.log(error.response);
      });
  };

  render() {
    return (
      <Row className="justify-content-center align-items-center d-flex mt-5">
        <Colxx xxs="12" md="8">
          <Card className="auth-card">
            <div className="form-side justify-content-center align-items-center d-flex flex-column">
              <div className="logo-single mb-2" />

              <CardTitle className="mb-5">ورود اطلاعات و ثبت نام</CardTitle>

              <div className="flex-column w-100 justify-content-center">
                <FormGroup className="w-md-50 w-100 mx-1">
                  <Label>موبایل</Label>
                  <Input
                    value={this.state.Mobile}
                    maxLength={11}
                    disabled={true}
                    onChange={(e) => this.setState({ Mobile: e.target.value })}
                  />
                </FormGroup>
                <FormGroup className="w-md-50 w-100 mx-1">
                  <Label>نام صاحب کالا</Label>
                  <Input
                    value={this.state.Firstname}
                    maxLength={300}
                    onChange={(e) =>
                      this.setState({ Firstname: e.target.value })
                    }
                  />
                </FormGroup>{" "}
                <FormGroup className="w-md-50 w-100 mx-1">
                  <Label>نام خانوادگی</Label>
                  <Input
                    value={this.state.Lastname}
                    maxLength={300}
                    onChange={(e) =>
                      this.setState({ Lastname: e.target.value })
                    }
                  />
                </FormGroup>
                <FormGroup className="w-md-50 w-100 mx-1">
                  <Label>کد ملی</Label>
                  <Input
                    value={this.state.MeliCode}
                    maxLength={11}
                    onChange={(e) =>
                      this.setState({ MeliCode: e.target.value })
                    }
                  />
                </FormGroup>
                <div className="flex-column w-100 justify-content-center">
                  <FormGroup className="w-md-50 w-100 mx-1">
                    <Label>استان</Label>
                    <Autocomplete
                      clearText={"حذف"}
                      closeText={"بستن"}
                      noOptionsText={"در حال دریافت اطلاعات.."}
                      openText={"باز کردن"}
                      className="react-select__control"
                      id="Province"
                      options={this.state.ProvinceList}
                      getOptionLabel={(option) => option.provinceName}
                      value={this.state.Province}
                      onChange={(e, v) =>
                        this.selectHandleChange(e, v, "Province")
                      }
                      renderInput={(params) => (
                        <TextField {...params} variant="standard" />
                      )}
                    />
                  </FormGroup>

                  <FormGroup className="w-md-50 w-100 mx-1">
                    <Label>شهر</Label>
                    <Autocomplete
                      clearText={"حذف"}
                      closeText={"بستن"}
                      noOptionsText={"در حال دریافت اطلاعات.."}
                      openText={"باز کردن"}
                      className="react-select__control"
                      id="City"
                      options={this.state.CityList}
                      getOptionLabel={(option) => option.cityName}
                      value={this.state.City}
                      onChange={(e, v) => this.selectHandleChange(e, v, "City")}
                      renderInput={(params) => (
                        <TextField {...params} variant="standard" />
                      )}
                    />
                  </FormGroup>
                </div>
                <div className="flex-column w-100 justify-content-center">
                  <FormGroup className="w-md-25 w-100 mx-1">
                    <label className="form-title">
                      تصویر کارت ملی (jpg,pdf)
                    </label>

                    <input
                      style={{ cursor: "cell" }}
                      className="input"
                      value={
                        this.state.file !== null
                          ? this.state.file.name
                          : "لطفا یک فایل انتخاب کنید"
                      }
                      onClick={() => this.fileUploader.current.click()}
                    />
                    <input
                      ref={this.fileUploader}
                      style={{ display: "none" }}
                      type="file"
                      onChange={(e) => {
                        this.setState({ file: e.target.files[0] });
                      }}
                    />
                  </FormGroup>
                </div>
                <Button
                  color="primary"
                  className="btn-lg mx-2"
                  onClick={() => this.validateInputData()}
                >
                  ثبت نام
                </Button>
                <Link to={"/"} type="button">
                  <Button outline color="warning" className="mx-3 my-md-0 my-1">
                    بازگشت
                  </Button>
                </Link>
              </div>

              {this.state.showNewMember === true && (
                <div className="d-flex flex-md-row flex-column w-100 justify-content-center">
                  <FormGroup className="w-md-50 w-100 mx-1">
                    <Label> نام کاربری</Label>
                    <Input
                      value={this.state.newMemberUsername}
                      disabled
                      onChange={(e) =>
                        this.setState({ newMemberUsername: e.target.value })
                      }
                    />
                  </FormGroup>
                  <FormGroup className="w-md-50 w-100 mx-1">
                    <Label> کلمه عبور</Label>
                    <Input
                      value={this.state.newMemberPassword}
                      disabled
                      onChange={(e) =>
                        this.setState({ newMemberPassword: e.target.value })
                      }
                    />
                  </FormGroup>
                </div>
              )}
            </div>
          </Card>
        </Colxx>
      </Row>
    );
  }
}
const mapStateToProps = ({ authUser }) => {
  const { user, loading } = authUser;
  return { user, loading };
};

export default connect(mapStateToProps, {
  registerUser,
})(RegisterProductOwner);
